import React, { Component } from 'react'
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import {Link} from 'react-router';

const Styles = {
  Card: {
    width: 150,
    height: 150,
    textAlign: 'center',
    margin: 20
  },
  CardContainer: {
    height: '100%'
  },
  InnerCard: {
    height: '100%',
    width: '100%',
    display: 'table'
  },
  InnerCardMiddleContainer: {
    display: 'table-cell',
    verticalAlign: 'middle'
  }
};

class DashboardCard extends Component {
  render() {    
    return (
      <Card style={Styles.Card} containerStyle={Styles.CardContainer}>
        <Link to={this.props.apiRoute}>
          <div style={Styles.InnerCard}>
            <div style={Styles.InnerCardMiddleContainer}>
              {this.props.icon}
              <CardText>
                {this.props.title}
              </CardText>
            </div>
          </div>
        </Link>
      </Card>
    )
  }
}

export default DashboardCard;


/** WEBPACK FOOTER **
 ** ./src/app/components/dashboardCard.js
 **/